import { render, staticRenderFns } from "./ProjectPowerUser.vue?vue&type=template&id=13655b4f&scoped=true&"
import script from "./ProjectPowerUser.vue?vue&type=script&lang=js&"
export * from "./ProjectPowerUser.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPowerUser.vue?vue&type=style&index=0&id=13655b4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13655b4f",
  null
  
)

export default component.exports